import { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { ROUTES } from '../../constants';
import { authContext } from '../../contexts/AuthContext';

type ProtectedRouteProps = {
  path: string;
  exact?: boolean;
  component: React.FC<unknown>;
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  path,
  ...rest
}) => {
  const { isAuth } = useContext(authContext);
  return (
    <div>
      <Route
        path={path}
        render={() =>
          isAuth ? <Component {...rest} /> : <Redirect to={ROUTES.LOGIN} />
        }
      />
    </div>
  );
};
